import styles from './BackgroundAnimation.module.scss';

const BackgroundAnimation = () => {
  return (
    <div className={styles.backgroundAnimation}>
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className={styles.floatingShape}
        />
      ))}
    </div>
  );
};

export default BackgroundAnimation;